import { Stack, Switch, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useLog from "../../hooks/useLog";

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const [checked, setChecked] = useState(i18n.language === 'en');
  const { LogInfo } = useLog();

  const handleToggle = () => {
    const newLang = checked ? 'he' : 'en';
    i18n.changeLanguage(newLang);
    LogInfo(`Language changed to ${newLang}`);
    setChecked((prev) => !prev);
  };
  

  return (
    <Stack direction="row" alignItems="center" sx={{m: 2}}>
      {i18n.language === 'he' ? <Typography>English</Typography> : <Typography>עברית</Typography>}

    <Switch id="languageSwitch"   onChange={handleToggle}
     checked={checked}
    sx={{
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: 'primary.main',
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: 'primary.main',
        },
        '& .MuiSwitch-switchBase': {
          color: 'primary.main',
        },
        '& .MuiSwitch-track': {
          backgroundColor: 'primary.main',
        },
      }}/>
        {i18n.language === 'he' ? <Typography>עברית</Typography> : <Typography>English</Typography>}
      </Stack>
  );
}